import React, { useState } from 'react';
import { Button, Divider } from 'antd';
import LabelledInput from 'components/LabelledInput';
import { UndefinedAble } from 'data/base';
import ReactJson from 'react-json-view';
import { t } from 'helpers/i18n';
import { showError } from 'store/popup/actions';
import { useDispatch } from 'react-redux';
import { decryptHestiaApp, decryptPandoraConfig } from 'util/terraCrypto';
import { HestiaApp } from 'data/terra/api/terra/response/HestiaAppsResponse';

enum UrlType {
  Pandora,
  Hestia,
}

const PlaygroundContainer = () => {
  const dispatch = useDispatch();
  const [url, setUrl] = useState<UndefinedAble<string>>();
  const [clientIdToPreview, setClientIdToPreview] = useState<string>('');
  const [decodedConfig, setDecodedConfig] = useState<any>();

  const onPreviewConfig = async () => {
    if (url) {
      const urlType = getUrlType(url);
      const clientId = extractClientId(url, urlType);
      if (clientId) {
        setClientIdToPreview(clientId);
        try {
          const response = await fetch(url);
          if (response.status === 200) {
            const raw = await response.json();
            let decrypted;
            if (urlType === UrlType.Pandora) {
              decrypted = decryptPandoraConfig(raw.data, clientId);
            } else {
              if (Array.isArray(raw.data)) {
                decrypted = raw.data.map((e: HestiaApp) =>
                  decryptHestiaApp(e as HestiaApp, clientId)
                );
              } else {
                decrypted = decryptHestiaApp(raw.data as HestiaApp, clientId);
              }
            }
            setDecodedConfig(decrypted);
          } else {
            dispatch(showError(response.statusText));
          }
        } catch (error) {
          dispatch(showError((error as Error).message));
        }
      } else {
        dispatch(showError('Link khong hop le'));
      }
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', padding: '20px' }}>
      <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
        <div style={{ flex: 1, marginRight: '8px' }}>
          <LabelledInput
            label={t('Terra link')}
            helperText={t('Terra link')}
            value={url}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setUrl(event.target.value);
            }}
            marginBottom={true}
            mode="horizontal"
            onKeyDown={onPreviewConfig}
          />
        </div>
        <Button onClick={onPreviewConfig}>{t('Preview')}</Button>
      </div>
      <Divider />
      {clientIdToPreview ? <h3>Client ID: {clientIdToPreview}</h3> : null}
      <ReactJson
        src={decodedConfig}
        name={null}
        iconStyle="circle"
        displayDataTypes={false}
        displayObjectSize={false}
        collapseStringsAfterLength={50}
        enableClipboard={true}
      />
    </div>
  );
};

export default PlaygroundContainer;

function getUrlType(source: string): UrlType {
  if (source.includes('pandora')) {
    return UrlType.Pandora;
  } else if (source.includes('hestia')) {
    return UrlType.Hestia;
  } else {
    throw Error('UrlType undefined');
  }
}

function extractClientId(
  source: string,
  urlType: UrlType
): UndefinedAble<string> {
  let token = '';
  if (urlType === UrlType.Pandora) {
    token = 'pandora/';
  } else if (urlType === UrlType.Hestia) {
    token = 'hestia/';
  }

  const start = source.indexOf(token);
  if (start !== -1) {
    const subStr = source.slice(start + token.length);
    let end = subStr.indexOf('/');
    end = end !== -1 ? end : subStr.length;
    return window.atob(subStr.slice(0, end));
  } else {
    return undefined;
  }
}
